import Cookies from 'js-cookie';
import { Api } from './index';

export const GetClients = async () => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.get('/auth/clientObject')
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const GetAllUsers = async () => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	if (Cookies.get('type') === 'super-admin') {
		const result = await Api.get('/auth/super-admin/get-users')
			.then(response => {
				return response;
			})
			.catch(e => {
				return e.response;
			});
		return result;
	}
	return false;
};

export const GetClientObjectUUID = async (uuid: string) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.get('/auth/clientObject/' + uuid)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});
	return result;
};

export const PostClientObject = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.post('/auth/clientObject', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const CreateClientUsers = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.post('/auth/super-admin/user', body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const EditClientUsers = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const userId = body.id;
	delete body.id;
	const result = await Api.put(
		'/auth/super-admin/user/' + userId.toString(),
		body
	)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const EditClient = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const uuid = body.uuid;
	delete body.uuid;
	const result = await Api.put('/auth/clientObject/' + uuid.toString(), body)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const FilterUser = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	let request_url = `/auth/super-admin/user?user_type=${body.user_type}`;
	console.log('Enter,,,,', body.is_active);
	if (body.is_active !== '') {
		request_url = request_url + `&is_active=${body.is_active}`;
	}
	if (body.organization !== null) {
		request_url = request_url + `&organization=${body.organization}`;
	}

	const result = await Api.get(request_url)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const FilterClients = async (body: any) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.get(`/auth/clientObject?is_active=${body.is_active}`)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};

export const GetReports = async (
	startDate: String,
	endDate: String,
	clientId: any
) => {
	Api.defaults.headers['Authorization'] = `Bearer  ${Cookies.get('access')}`;
	const result = await Api.get(
		`/api/get-requested-report/?start_date=${startDate}&end_date=${endDate}&clientId=${clientId}`
	)
		.then(response => {
			return response;
		})
		.catch(e => {
			return e.response;
		});

	return result;
};
